<app-modal-header [hasClose]='true' [title]="'Matriz de Referência'" (handleClose)="close()"></app-modal-header>

<div class="matrix-actions">
  <a
    id="print-btn"
    class="secondary primary-text"
    mat-raised-button
    (click)="printMatrix()"
    color="accent"
  > Imprimir </a>
</div>

<div class="info">

  <div>
    <span>CURSO: </span> {{matrix?.course?.description}}
  </div>

  <div>
    <span>VERSÃO DA MATRIZ: </span> {{matrix?.version}}
  </div>

  <div>
    <span>ITINERÁRIO: </span> {{matrix?.itinerary_version}}
  </div>

</div>
@if (loading) {
  <mat-progress-bar mode="indeterminate" style="width: inherit;"></mat-progress-bar>
}

@if (!loading) {
  <mat-dialog-content>
    <mat-tab-group>
      <mat-tab label="PROVA PRÁTICA">
        <div class="table-scroll">
          <table style="color: grey;" class="view-matrix">
            <thead>
              <tr>
                <th [attr.colspan]="2" class="general-competence">
                  <p> <span>COMPETÊNCIA GERAL: </span> {{matrix?.competence_description}} </p>
                </th>
                <th [attr.colspan]="(matrix?.capacities.length)">
                  <p> CAPACIDADES </p>
                </th>
              </tr>
              <tr>
                <th rowspan="3" class="head-competence">
                  <p> UNIDADES DE COMPETÊNCIA </p>
                </th>
                <th rowspan="3" class="head-competence">
                  <p> ELEMENTOS DE COMPETÊNCIA </p>
                </th>
                <th [attr.colspan]="(numberBasics.length)">
                  <p>BÁSICAS</p>
                </th>
                <th [attr.colspan]="(numberTecnic.length)">
                  <p>TÉCNICAS</p>
                </th>
                @if (numberManagement.length > 0) {
                  <th [attr.colspan]="(numberManagement.length)">
                    <p>GESTÃO</p>
                  </th>
                }
                @if (numberPsicomotor.length > 0) {
                  <th [attr.colspan]="(numberPsicomotor.length)">
                    <p>PSICOMOTOR</p>
                  </th>
                }
              </tr>
              <tr>
                @for (item of matrix?.capacities; track item) {
                  <th>
                    C{{item.code}}
                  </th>
                }
              </tr>
              <tr>
                @for (item of matrix?.capacities; track item) {
                  <th>
                    {{item.description}}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of competence_units; track item) {
                <tr>
                  @if (item.competency_unity_description) {
                    <td class="friendly" [attr.rowspan]="item.competency_unity_span">
                      <p>{{item?.competency_unity_description}}</p>
                    </td>
                  }
                  <td>{{item?.description}}</td>
                  @for (know of item.evidences_knowledges; track know) {
                    <td>
                      {{know}}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="div-container">
          <h1 style="width: 100%; margin-bottom: 10px; color: #450A6D;">OBJETOS DE CONHECIMENTO</h1>
          <div class="div-object">
            @for (item of matrix?.knowledges; track item) {
              <span class="span-object">
                {{sigla(item.code)}} - {{item.description}}
              </span>
            }
          </div>
        </div>
      </mat-tab>
      <mat-tab label="PROVA OBJETIVA">
        <div class="table-scroll">
          <table style="color: grey;" class="view-matrix">
            <thead>
              <tr>
                <th [attr.colspan]="2" class="general-competence">
                  <p> <span>COMPETÊNCIA GERAL: </span> {{matrix?.competence_description}} </p>
                </th>
                <th [attr.colspan]="(matrix?.capacities.length)">
                  <p> CAPACIDADES </p>
                </th>
              </tr>
              <tr>
                <th rowspan="3" class="head-competence">
                  <p> UNIDADES DE COMPETÊNCIA </p>
                </th>
                <th rowspan="3" class="head-competence">
                  <p> ELEMENTOS DE COMPETÊNCIA </p>
                </th>
                <th [attr.colspan]="(numberBasics.length)">
                  <p>BÁSICAS</p>
                </th>
                <th [attr.colspan]="(numberTecnic.length)">
                  <p>TÉCNICAS</p>
                </th>
                @if (numberManagement.length > 0) {
                  <th [attr.colspan]="(numberManagement.length)">
                    <p>GESTÃO</p>
                  </th>
                }
                @if (numberPsicomotor.length > 0) {
                  <th [attr.colspan]="(numberPsicomotor.length)">
                    <p>PSICOMOTOR</p>
                  </th>
                }
              </tr>
              <tr>
                @for (item of matrix?.capacities; track item) {
                  <th>
                    C{{item.code}}
                  </th>
                }
              </tr>
              <tr>
                @for (item of matrix?.capacities; track item) {
                  <th>
                    {{item.description}}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of competence_units; track item) {
                <tr>
                  @if (item.competency_unity_description) {
                    <td class="friendly" [attr.rowspan]="item.competency_unity_span">
                      <p>{{item?.competency_unity_description}}</p>
                    </td>
                  }
                  <td>{{item?.description}}</td>
                  @for (know of item.competences_elements_capacities; track know) {
                    <td>
                      {{know}}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="div-container">
          <h1 style="width: 100%; margin-bottom: 10px; color: #450A6D;">OBJETOS DE CONHECIMENTO</h1>
          <div class="div-object">
            @for (item of matrix?.knowledges; track item) {
              <span class="span-object">
                {{sigla(item.code)}} - {{item.description}}
              </span>
            }
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
}

<div class="content-copy-to-print">
  <table id="document-header">
    <tbody>
      <tr>
        <td><span>CURSO: </span> {{matrix?.course.description}}</td>
        <td><span>VERSÃO DA MATRIZ: </span> {{matrix?.version}}</td>
        <td><span>ITINERÁRIO: </span> {{matrix?.itinerary_version}}</td>
      </tr>
    </tbody>
  </table>

  <table id="table1" style="color: grey;" class="view-matrix">

    <thead>
      <tr>
        <th [attr.colspan]="(matrix?.capacities.length) + 2">PROVA PRÁTICA</th>
      </tr>
      <tr>
        <th [attr.colspan]="2" class="general-competence">
          <p> <span>COMPETÊNCIA GERAL: </span> {{matrix?.competence_description}} </p>
        </th>
        <th [attr.colspan]="(matrix?.capacities.length)">
          <p> CAPACIDADES </p>
        </th>
      </tr>
      <tr>
        <th rowspan="3" class="head-competence">
          <p> UNIDADES DE COMPETÊNCIA </p>
        </th>
        <th rowspan="3" class="head-competence">
          <p> ELEMENTOS DE COMPETÊNCIA </p>
        </th>
        <th [attr.colspan]="(numberBasics.length)">
          <p>BÁSICAS</p>
        </th>
        <th [attr.colspan]="(numberTecnic.length)">
          <p>TÉCNICAS</p>
        </th>
        @if (numberManagement.length > 0) {
          <th [attr.colspan]="(numberManagement.length)">
            <p>GESTÃO</p>
          </th>
        }
        @if (numberPsicomotor.length > 0) {
          <th [attr.colspan]="(numberPsicomotor.length)">
            <p>PSICOMOTOR</p>
          </th>
        }
      </tr>
      <tr>
        @for (item of matrix?.capacities; track item) {
          <th>
            C{{item.code}}
          </th>
        }
      </tr>
      <tr>
        @for (item of matrix?.capacities; track item) {
          <th>
            {{item.description}}
          </th>
        }
      </tr>
    </thead>

    <tbody>

      @for (item of competence_units; track item) {
        <tr>
          @if (item.competency_unity_description) {
            <td class="friendly" [attr.rowspan]="item.competency_unity_span">
              <p>{{item?.competency_unity_description}}</p>
            </td>
          }
          <td>{{item?.description}}</td>
          @for (know of item.evidences_knowledges; track know) {
            <td>
              {{know}}
            </td>
          }
        </tr>
      }

    </tbody>

  </table>

  <table id="OC1">
    <thead>
      <tr>
        <th colspan="4">OBJETOS DE CONHECIMENTO</th>
      </tr>
    </thead>

    <tbody>
      @for (item of matrix?.knowledges; track item) {
        <tr>
          <td colspan="4">{{sigla(item.code)}} - {{item.description}}</td>
        </tr>
      }
    </tbody>
  </table>

  <table id="table2" style="color: grey;" class="view-matrix">

    <thead>
      <tr>
        <th [attr.colspan]="(matrix?.capacities.length) + 2">PROVA OBJETIVA</th>
      </tr>
      <tr>
        <th [attr.colspan]="2" class="general-competence">
          <p> <span>COMPETÊNCIA GERAL: </span> {{matrix?.competence_description}} </p>
        </th>
        <th [attr.colspan]="(matrix?.capacities.length)">
          <p> CAPACIDADES </p>
        </th>
      </tr>
      <tr>
        <th rowspan="3" class="head-competence">
          <p> UNIDADES DE COMPETÊNCIA </p>
        </th>
        <th rowspan="3" class="head-competence">
          <p> ELEMENTOS DE COMPETÊNCIA </p>
        </th>
        <th [attr.colspan]="(numberBasics.length)">
          <p>BÁSICAS</p>
        </th>
        <th [attr.colspan]="(numberTecnic.length)">
          <p>TÉCNICAS</p>
        </th>
        @if (numberManagement.length > 0) {
          <th [attr.colspan]="(numberManagement.length)">
            <p>GESTÃO</p>
          </th>
        }
        @if (numberPsicomotor.length > 0) {
          <th [attr.colspan]="(numberPsicomotor.length)">
            <p>PSICOMOTOR</p>
          </th>
        }
      </tr>
      <tr>
        @for (item of matrix?.capacities; track item) {
          <th>
            C{{item.code}}
          </th>
        }
      </tr>
      <tr>
        @for (item of matrix?.capacities; track item) {
          <th>
            {{item.description}}
          </th>
        }
      </tr>
    </thead>

    <tbody>

      @for (item of competence_units; track item) {
        <tr>
          @if (item.competency_unity_description) {
            <td class="friendly" [attr.rowspan]="item.competency_unity_span">
              <p>{{item?.competency_unity_description}}</p>
            </td>
          }
          <td>{{item?.description}}</td>
          @for (know of item.competences_elements_capacities; track know) {
            <td>
              {{know}}
            </td>
          }
        </tr>
      }

    </tbody>

  </table>
</div>
